import bundledPublicationsSnapshot from '~/data/publications.json'
import type {
  PublicationEntry,
  PublicationLink,
  PublicationsSnapshot,
} from './publicationsData'

const publicationsSnapshot =
  bundledPublicationsSnapshot as unknown as PublicationsSnapshot

let publicationsPromise: Promise<PublicationEntry[]> | null = null

export async function getAllPublications(): Promise<PublicationEntry[]> {
  if (!publicationsPromise) {
    publicationsPromise = Promise.resolve(publicationsSnapshot.publications)
  }

  return publicationsPromise
}

export type { PublicationEntry, PublicationLink, PublicationsSnapshot }
